/* eslint-disable react-hooks/exhaustive-deps */
import Swal from 'sweetalert2'

/*Icons type -> success error warning info question*/

const ToastUtils = ({type, message}) =>
  Swal.fire({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000, // Adjust the time the popup stays visible
    showClass: {
      popup: 'swal2-show',
      icon: 'swal2-icon',
    },
    hideClass: {
      popup: 'swal2-hide',
      icon: 'swal2-icon',
    },
    customClass: {
      container: 'custom-swal-container',
      popup: 'custom-swal-popup',
      icon: 'custom-swal-icon',
    },
    icon: type,
    title: message,
  })

// const ToastUtils = ({type, message}) => {
//   type = type === 'error' ? 'danger' : type
//   const triggerAlert = () => {
//     // Create alert container dynamically
//     const alertDiv = document.createElement('div')
//     alertDiv.className = `alert alert-${type} custom-alert`
//     alertDiv.setAttribute('role', 'alert')

//     alertDiv.style.position = 'fixed'
//     alertDiv.style.top = '1rem'
//     alertDiv.style.right = '1rem'
//     alertDiv.style.zIndex = '1050'
//     alertDiv.style.width = '500px'
//     alertDiv.style.transition = 'opacity 0.5s ease-in-out'

//     alertDiv.innerHTML = message

//     // Append alert to body
//     document.body.appendChild(alertDiv)

//     // Auto-remove the alert after 3 seconds
//     setTimeout(() => {
//       alertDiv.style.opacity = '0' // Fade out
//       setTimeout(() => alertDiv.remove(), 500) // Remove after fade-out
//     }, 3000)
//   }

//   triggerAlert()
// }

// old swal
/*Swal.fire({
    position: 'top-end',
    //icon: type,
    title: message,
    showConfirmButton: false,
    timer: 1500,
  }) */

export const ErrorToastUtils = (message = 'Something Went Wrong') => {
  ToastUtils({type: 'error', message: message})
}

export default ToastUtils
